import { render, staticRenderFns } from "./TracksReadOnlyPanel.vue?vue&type=template&id=5638fa6e"
import script from "./TracksReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./TracksReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports